import { Component, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { StoreService } from './../../store.service'


@Component({
  selector: 'app-delete-dialog', 
  templateUrl: './delete-form.dialog.html',
})
export class DeleteFormDialog {

  @Input() skillId: any

  constructor(
    public dialog: MatDialog
  ) {}

  openDialog() {
    this.dialog.open(DeleteFormComponent,{data: { skillId: this.skillId}});
  }

}


@Component({
  selector: 'app-delete-form',
  templateUrl: './delete-form.component.html',
  styleUrls: ['./delete-form.component.css']
})
export class DeleteFormComponent {

  constructor(
    public dialogRef: MatDialogRef<DeleteFormComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private $store: StoreService
  ) {}

  deleteExpertise(){
    this.$store.deleteSkill(this.data.skillId)
        .then(
          () => this.closeDialog()
        )
        .catch(err => console.log('There was error', err))
  }

  closeDialog() {
    this.dialogRef.close()
  }

}



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/profile/delete-form/delete-form.component.ts